import { Component, Input, OnInit } from '@angular/core';
import { ToggleSwitchConfig, toggleOption } from './toggle-switch-config';

@Component({
    selector: 'toggle-switch',
    templateUrl: 'toggle-switch.component.html',
    styleUrls: ['toggle-switch.component.scss']
})

export class ToggleSwitchComponent implements OnInit {
    @Input() config:ToggleSwitchConfig = {
        option1:{
            label:'Modules',
            isActive:true,
            value:'modules',
            action:()=>{}
        },
        option2:{
            label:'Journey',
            isActive:false,
            value:'journey',
            action:()=>{}
        }
    }
    constructor() { }

    ngOnInit() { }
    /**
     * @description handles the click event on button
     * @param option 
     */
    onClick(option:toggleOption):void{
        if(!option.isActive){
            option.action();
        }
    }
}